import type { ColoresMarca } from './contraste';

/** Marca blanca del tenant (GET /admin/marca). Los colores se traducen a tokens CSS. */
export interface Marca extends ColoresMarca {
  nombre_producto?: string;
  logo_url?: string | null;
  pie_legal?: string | null;
  tipografia?: string | null;
}

export const MARCA_POR_DEFECTO: Marca = {
  nombre_producto: 'Tarja',
  // Paleta homologada con Suel2 Nómina (brand-600 índigo, fondo gray-50, texto gray-900).
  color_primario: '#4f46e5',
  color_texto_primario: '#ffffff',
  color_fondo: '#f9fafb',
  color_texto: '#111827',
  color_superficie: '#ffffff',
  color_acento: '#b45309',
  logo_url: null,
  pie_legal: null,
  tipografia: null,
};

const MAPA: Record<keyof ColoresMarca, string> = {
  color_primario: '--t-primario',
  color_texto_primario: '--t-primario-texto',
  color_fondo: '--t-fondo',
  color_texto: '--t-texto',
  color_superficie: '--t-superficie',
  color_acento: '--t-acento',
};

/**
 * Aplica la marca como propiedades CSS en :root. Usa CSSOM (style.setProperty), compatible con una CSP
 * sin 'unsafe-inline' en style-src.
 */
export function aplicarMarca(marca: Partial<Marca>, raiz: HTMLElement = document.documentElement): void {
  for (const [campo, variable] of Object.entries(MAPA) as [keyof ColoresMarca, string][]) {
    const valor = marca[campo];
    if (typeof valor === 'string' && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(valor)) raiz.style.setProperty(variable, valor);
  }
  if (marca.tipografia) raiz.style.setProperty('--t-fuente', `${marca.tipografia}, system-ui, sans-serif`);
  if (marca.nombre_producto) document.title = marca.nombre_producto;
}

export function limpiarMarca(raiz: HTMLElement = document.documentElement): void {
  for (const variable of Object.values(MAPA)) raiz.style.removeProperty(variable);
  raiz.style.removeProperty('--t-fuente');
}
